exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-Post-___styles__new-item___3ilLH {\n    max-height: 0px;\n    animation: src-components-Post-___styles__grow___1hTbJ 500ms ease forwards;\n}\n\n.src-components-Post-___styles__remove-item___3wtlE {\n    max-height: 500px;\n    animation: src-components-Post-___styles__shrink___13kXH 500ms ease forwards;\n}\n\n@keyframes src-components-Post-___styles__grow___1hTbJ {\n    to {\n        max-height: 500px;\n    }\n}\n\n@keyframes src-components-Post-___styles__shrink___13kXH {\n    to {\n        max-height: 0px;\n    }\n}\n", ""]);

// exports
exports.locals = {
	"new-item": "src-components-Post-___styles__new-item___3ilLH",
	"grow": "src-components-Post-___styles__grow___1hTbJ",
	"remove-item": "src-components-Post-___styles__remove-item___3wtlE",
	"shrink": "src-components-Post-___styles__shrink___13kXH"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./src/components/Post/styles.css
// module id = 162
// module chunks = 0